export const activityTypeList = [
    {
        value:1,
        label:'新用户有礼',
        desc:'新用户注册登录后首页将会显示该条弹窗，点击弹窗即可获取相应的奖励。',
        component: () => import(
            '../views/ActivityRules.vue')
    },
    {
        value:2,
        label:'邀请有礼',
        desc:'通过邀请按钮将邀请链接放松给其他未注册的用户，该用户通过这个链接注册登录后，邀请人可获取相应的奖励。',
        component: () => import(
            '../views/ActivityRules.vue')
    },
    {
        value:3,
        label:'平台活动福利',
        desc:'在首页弹窗上传弹框图片等信息，用户可点击进行下一步操作或直接领取奖励。',
        component: () => import(
            '../views/ActivityRules.vue')
    }
]